import {InjectionToken} from '@angular/core'

/**
 * Defines and exports an injection token that replaces the browser
 * window object.
 */
export const WINDOW = new InjectionToken<Window>('window')

export const LOGIN_PATH = 'login'
export const USER_ROLE_NAME = 'blockBankIdUser'
export const ADMIN_ROLE_NAME = 'blockBankIdAdmin'